import { MenuItem } from '../fw/services/menu.service';

export let initialMenuItems: Array<MenuItem> = [
    {
        text: 'KLANTEN',
        image: '../../assets/images/menuCustomer.png',
        route: null,
        submenu: [
            {
                text: 'KLANT ZOEKEN',
                route: '/auth/customer-search'
            },
            {
                text: 'KLANT OVERZICHTEN',
                route: '/auth/customer-overview'
            }
        ]
    },
    {
        text: 'MEDEWERKERS',
        image: '../../assets/images/menuEmployee.png',
        route: null,
        submenu: [
            {
                text: 'MEDEWERKERGEGEVENS',
                route: '/auth/employee-list'
            },
            {
                text: 'URENOVERZICHT',
                route: '/auth/employee-hour-oveview'
            }
        ]
    },
    {
        text: 'VOORRAAD',
        image: '../../assets/images/menuStock.png',
        route: null,
        submenu: [
            {
                text: 'VOORRAAD OVERZICHT',
                route: '/auth/stock-overview'
            },
            {
                text: 'INVENTARISATIE',
                route: '/auth/stock-inventory'
            }
        ]
    },
    {
        text: 'ADMINISTRATIE',
        image: '../../assets/images/menuCashreg.png',
        route: null,
        submenu: [
            {
                text: 'DAGSTAAT',
                route: '/auth/administration-cashreg-day'
            },
            {
                text: 'WEEKSTAAT',
                route: '/auth/administration-cashreg-week'
            },
            {
                text: 'KASBOEK',
                route: '/auth/administration-cashbook'
            },
            {
                text: 'ZOEK KASSTORTING',
                route: '/auth/administration-deposit'
            },
            {
                text: 'KADOBONNEN',
                route: '/auth/administration-vouchers'
            }
        ]
    },
    {
        text: 'MANAGEMENT',
        image: '../../assets/images/menuStats.png',
        route: null,
        submenu: [
            {
                text: 'QUICKVIEW SALONS',
                route: '/auth/management-quickview'
            },
            {
                text: 'BEHANDELINGEN & VERKOOP',
                route: '/auth/management-sales-goal'
            },
            {
                text: 'DETAILGEGEVENS BEHANDELINGEN',
                route: '/auth/management-treatment-info'
            },
            {
                text: 'DETAILGEGEVENS ARTIKELEN',
                route: '/auth/management-article-info'
            },
            {
                text: 'DETAILGEGEVENS KLANTEN',
                route: '/auth/management-customer-info'
            },
            {
                text: 'DETAILGEGEVENS MEDEWERKERS',
                route: '/auth/management-employee-info'
            }
        ]
    },
    {
        text: 'MARKETING',
        image: '../../assets/images/menuMarketing.png',
        route: null,
        submenu: [
            {
                text: 'KLANT SELECTIE & MAILING',
                route: '/auth/mailing'
            },
            {
                text: 'DETAILGEGEVENS MARKETING',
                route: '/auth/marketing-info'
            },
            {
                text: 'KLANTTEVREDENHEIDSONDERZOEK',
                route: '/auth/customer-satisfaction-survey'
            }
        ]
    },
    {
        text: 'VESTIGINGEN',
        image: '../../assets/images/menuBranches.png',
        route: '/auth/branches-list',
        submenu: []
    },
    {
        text: 'INSTELLINGEN',
        image: '../../assets/images/menuSettings.png',
        route: null,
        submenu: [
            {
                text: 'BASISINSTELLINGEN',
                route: '/auth/settings-base'
            },
            {
                text: 'KASSA INSTELLINGEN',
                route: '/auth/settings-cashreg'
            },
            {
                text: 'AGENDA INSTELLINGEN',
                route: '/auth/settings-planner'
            },
            {
                text: 'BEVEILIGINGSINSTELLINGEN',
                route: '/auth/settings-security'
            },
            {
                text: 'KLEURKAARTINSTELLINGEN',
                route: '/auth/settings-eventaction-color'
            },
            {
                text: 'PERMANENTINSTELLINGEN',
                route: '/auth/settings-eventaction-perm'
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/app.menu.ts